import { render } from "./RecordView.vue?vue&type=template&id=017006c4&scoped=true"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"

import "./RecordView.vue?vue&type=style&index=0&id=017006c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017006c4"]])

export default __exports__